/* ==========================================================================
   Verolae · main-product behaviour (port of the source site product page scripts)
   Source: sections/product/03_main.html inline scripts
     #2  gallery overlay arrows + thumbnail drag-scroll
     #3/#8 UGC video carousel (arrows, inline play/pause, drag)
     #4  "% Sold" progress bar count-up
     #5/#7 sale badge + in-button price sync on variant change
     #9  Why-trust reveal animation
     #13 accordion open/close animation
   Everything is scoped to one <product-info class="verolae-main-product"> instance
   (data-section = section id) and is dependency-free. Analytics/pixels: none.
   ========================================================================== */
(function () {
  'use strict';

  /* ------------------------------------------------------------------ */
  /* Money helpers (identical to the source)                             */
  /* ------------------------------------------------------------------ */
  function formatMoney(cents, moneyFmt) {
    var fmt = moneyFmt || '${{amount}}';
    var amount = (cents / 100).toFixed(2);
    var amountNoD = String(Math.round(cents / 100));
    var amountComma = amount.replace('.', ',');
    return fmt
      .replace(/\{\{\s*amount\s*\}\}/g, amount)
      .replace(/\{\{\s*amount_no_decimals\s*\}\}/g, amountNoD)
      .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/g, amountComma)
      .replace(/\{\{\s*amount_no_decimals_with_comma_separator\s*\}\}/g, amountNoD.replace('.', ','));
  }

  function parseToCents(str) {
    var s = String(str || '').replace(/[^\d.,]/g, '');
    if (!s) return 0;
    if (/,\d{2}$/.test(s) && s.indexOf('.') === -1) {
      s = s.replace(',', '.');
    } else {
      s = s.replace(/,/g, '');
    }
    return Math.round(parseFloat(s) * 100) || 0;
  }

  /* ------------------------------------------------------------------ */
  /* 1. Gallery overlay arrows (source SCRIPT#2)                         */
  /* ------------------------------------------------------------------ */
  function initGalleryArrows(root, sectionId) {
    var viewer = root.querySelector('#GalleryViewer-' + sectionId);
    if (!viewer) return;

    var prevBtn = viewer.querySelector('button[name="previous"]');
    var nextBtn = viewer.querySelector('button[name="next"]');
    var slider = viewer.querySelector('[id^="Slider-"]');
    if (!prevBtn || !nextBtn || !slider) return;

    var thumbsSelector = '#Slider-Thumbnails-' + sectionId + ' .thumbnail-list__item';
    function thumbItems() {
      return Array.prototype.slice.call(root.querySelectorAll(thumbsSelector));
    }

    // Desktop logic: active thumbnail detection and custom click handling
    function updateDesktopArrows() {
      if (window.innerWidth < 750) return;
      var items = thumbItems();
      if (items.length <= 1) {
        prevBtn.setAttribute('data-inactive', 'true');
        nextBtn.setAttribute('data-inactive', 'true');
        return;
      }
      var activeIndex = -1;
      items.some(function (item, i) {
        if (item.querySelector('button[aria-current="true"]')) { activeIndex = i; return true; }
        return false;
      });
      if (activeIndex <= 0) prevBtn.setAttribute('data-inactive', 'true');
      else prevBtn.removeAttribute('data-inactive');
      if (activeIndex >= items.length - 1) nextBtn.setAttribute('data-inactive', 'true');
      else nextBtn.removeAttribute('data-inactive');
    }

    // Mobile logic: standard scroll position detection
    function updateArrowStates() {
      if (window.innerWidth < 750) {
        var scrollLeft = slider.scrollLeft;
        var maxScroll = slider.scrollWidth - slider.clientWidth;
        if (scrollLeft <= 40) prevBtn.setAttribute('data-inactive', 'true');
        else prevBtn.removeAttribute('data-inactive');
        if (scrollLeft >= maxScroll - 40) nextBtn.setAttribute('data-inactive', 'true');
        else nextBtn.removeAttribute('data-inactive');
      } else {
        updateDesktopArrows();
      }
    }

    function step(delta) {
      return function (e) {
        if (window.innerWidth < 750) return;
        e.preventDefault();
        e.stopPropagation();
        var items = thumbItems();
        var activeIndex = -1;
        items.some(function (item, i) {
          if (item.querySelector('button[aria-current="true"]')) { activeIndex = i; return true; }
          return false;
        });
        var target = activeIndex + delta;
        if (activeIndex !== -1 && target >= 0 && target < items.length) {
          var btn = items[target].querySelector('button');
          if (btn) btn.click();
          updateDesktopArrows();
        }
      };
    }
    prevBtn.addEventListener('click', step(-1));
    nextBtn.addEventListener('click', step(1));

    // Listen to thumbnail button clicks to update arrows state
    root.querySelectorAll('#Slider-Thumbnails-' + sectionId + ' button').forEach(function (btn) {
      btn.addEventListener('click', function () { setTimeout(updateDesktopArrows, 50); });
    });

    slider.addEventListener('scroll', updateArrowStates, { passive: true });
    window.addEventListener('resize', updateArrowStates, { passive: true });

    updateArrowStates();
    setTimeout(updateArrowStates, 100);
    setTimeout(updateArrowStates, 300);
    setTimeout(updateArrowStates, 600);
    setTimeout(updateArrowStates, 1000);
  }

  // Drag-to-scroll for desktop thumbnails
  function initDragScroll(root, sectionId) {
    var slider = root.querySelector('#Slider-Thumbnails-' + sectionId);
    if (!slider) return;

    var isDown = false;
    var startX;
    var scrollLeft;
    var hasMoved = false;

    slider.addEventListener('mousedown', function (e) {
      if (window.innerWidth < 750) return; // Only drag on desktop
      isDown = true;
      hasMoved = false;
      startX = e.pageX - slider.offsetLeft;
      scrollLeft = slider.scrollLeft;
    });
    slider.addEventListener('mouseleave', function () { isDown = false; });
    slider.addEventListener('mouseup', function () { isDown = false; });
    slider.addEventListener('mousemove', function (e) {
      if (!isDown) return;
      var x = e.pageX - slider.offsetLeft;
      var walk = (x - startX) * 1.5;
      if (Math.abs(x - startX) > 5) hasMoved = true;
      slider.scrollLeft = scrollLeft - walk;
    });
    // Capture and prevent thumbnail click if dragging happened
    slider.addEventListener('click', function (e) {
      if (hasMoved) {
        e.preventDefault();
        e.stopPropagation();
      }
    }, true);
  }

  /* ------------------------------------------------------------------ */
  /* 2. UGC video carousel (source SCRIPT#3 / #8)                        */
  /* ------------------------------------------------------------------ */
  function initUgc(wrapper) {
    if (wrapper.dataset.ugcInit) return;
    wrapper.dataset.ugcInit = '1';

    var slider = wrapper.querySelector('.ugc-scroll-row');
    var prevBtn = wrapper.querySelector('.ugc-nav-btn--prev');
    var nextBtn = wrapper.querySelector('.ugc-nav-btn--next');
    if (!slider) return;

    var thumbs = Array.prototype.slice.call(slider.querySelectorAll('.ugc-thumbnail-wrapper'));

    /* ── Pause all inline videos and restore poster+button ── */
    function pauseAll() {
      thumbs.forEach(function (t) {
        var video = t.querySelector('video');
        var img = t.querySelector('img');
        var btn = t.querySelector('.ugc-play-btn');
        if (!video) return;
        if (!video.paused) {
          video.pause();
          video.currentTime = 0;
        }
        video.style.display = 'none';
        if (img) img.style.display = 'block';
        if (btn) btn.style.display = 'flex';
      });
    }

    /* ── Play a specific thumbnail ── */
    function playThumb(item) {
      pauseAll();
      var video = item.querySelector('video');
      var img = item.querySelector('img');
      var btn = item.querySelector('.ugc-play-btn');
      if (!video) return;
      if (img) img.style.display = 'none';
      if (btn) btn.style.display = 'none';
      video.style.display = 'block';
      var p = video.play();
      if (p && typeof p.catch === 'function') p.catch(function () {});
    }

    /* ── Arrow scroll navigation ── */
    if (prevBtn && nextBtn) {
      var getScrollStep = function () {
        if (thumbs.length > 0) return thumbs[0].clientWidth + 16;
        return 168;
      };
      var updateNavButtons = function () {
        var scrollLeft = slider.scrollLeft;
        var maxScrollLeft = slider.scrollWidth - slider.clientWidth;
        prevBtn.disabled = scrollLeft <= 5;
        nextBtn.disabled = scrollLeft >= maxScrollLeft - 5;
      };

      prevBtn.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        pauseAll();
        slider.scrollBy({ left: -getScrollStep(), behavior: 'smooth' });
      });
      nextBtn.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        pauseAll();
        slider.scrollBy({ left: getScrollStep(), behavior: 'smooth' });
      });

      slider.addEventListener('scroll', updateNavButtons, { passive: true });
      updateNavButtons();
      window.addEventListener('resize', updateNavButtons);
      window.addEventListener('load', updateNavButtons);
      setTimeout(updateNavButtons, 500);
      setTimeout(updateNavButtons, 1500);
    }

    slider.addEventListener('scroll', function () { pauseAll(); }, { passive: true });

    /* ── Pause when section scrolls out of viewport ── */
    if ('IntersectionObserver' in window) {
      var sectionObserver = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) pauseAll();
        });
      }, { threshold: 0.1 });
      sectionObserver.observe(slider);
    }

    /* ── Drag support ── */
    var isDown = false;
    var startX = 0;
    var scrollLeft = 0;
    var isDragging = false;

    slider.addEventListener('mousedown', function (e) {
      isDown = true;
      isDragging = false;
      startX = e.pageX - slider.offsetLeft;
      scrollLeft = slider.scrollLeft;
      slider.style.scrollSnapType = 'none';
    });
    slider.addEventListener('mouseleave', function () {
      isDown = false;
      slider.style.scrollSnapType = 'x mandatory';
    });
    slider.addEventListener('mouseup', function () {
      isDown = false;
      slider.style.scrollSnapType = 'x mandatory';
      setTimeout(function () { isDragging = false; }, 20);
    });
    slider.addEventListener('mousemove', function (e) {
      if (!isDown) return;
      var x = e.pageX - slider.offsetLeft;
      var walk = (x - startX) * 2;
      if (Math.abs(walk) > 5) isDragging = true;
      e.preventDefault();
      slider.scrollLeft = scrollLeft - walk;
    });

    thumbs.forEach(function (item) {
      item.addEventListener('click', function () {
        if (isDragging) return;
        var video = item.querySelector('video');
        if (video && !video.paused) pauseAll();
        else playThumb(item);
      });
    });
  }

  /* ------------------------------------------------------------------ */
  /* 3. "% Sold" progress bar (source SCRIPT#4)                          */
  /* ------------------------------------------------------------------ */
  function animateProgress(container) {
    if (container.classList.contains('js-animated')) return;
    var fill = container.querySelector('.ceylon-progress-bar-fill');
    var countEl = container.querySelector('.ceylon-progress-count');
    if (!fill || !countEl) return;
    var target = parseInt(fill.getAttribute('data-percent'), 10) || 0;

    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        container.classList.add('js-animated');
        fill.style.width = target + '%';

        var duration = 1200; // 1.2s
        var startTime = performance.now();
        function animateCount(timestamp) {
          var elapsed = timestamp - startTime;
          var progress = Math.min(elapsed / duration, 1);
          var easeProgress = progress * (2 - progress); // easeOutQuad
          countEl.textContent = Math.floor(easeProgress * target);
          if (progress < 1) requestAnimationFrame(animateCount);
          else countEl.textContent = target;
        }
        requestAnimationFrame(animateCount);
        observer.unobserve(container);
      });
    }, { threshold: 0.1 });
    observer.observe(container);
  }

  function initProgress(root) {
    root.querySelectorAll('.ceylon-progress-container').forEach(animateProgress);
  }

  document.addEventListener('shopify:block:select', function (event) {
    var el = event.target;
    if (!el || !el.classList || !el.classList.contains('ceylon-progress-container')) return;
    el.classList.remove('js-animated');
    var fill = el.querySelector('.ceylon-progress-bar-fill');
    var countEl = el.querySelector('.ceylon-progress-count');
    if (fill && countEl) {
      fill.style.width = '0%';
      countEl.textContent = '0';
    }
    animateProgress(el);
  });

  /* ------------------------------------------------------------------ */
  /* 4. Sale badge + in-button prices (source SCRIPT#5 / #7)             */
  /* ------------------------------------------------------------------ */
  function initPriceSync(root, sectionId) {
    var moneyFmt = root.dataset.moneyFormat || '${{amount}}';

    /* variant map from Liquid */
    var variants = [];
    var dataEl = root.querySelector('script[data-verolae-variants]');
    if (dataEl) {
      try { variants = JSON.parse(dataEl.textContent) || []; } catch (e) { variants = []; }
    }
    var variantMap = {};
    variants.forEach(function (v) { variantMap[v.id] = v; });
    function getVariant(id) { return variantMap[parseInt(id, 10)] || null; }

    /* Elements are re-queried on every update: Dawn re-renders the badge
       (#price-<section>) from the server on variant change. */
    function badgeEls() {
      var wrap = root.querySelector('.bsw');
      if (!wrap) return null;
      return {
        priceEl: wrap.querySelector('[data-badge-price]'),
        compareEl: wrap.querySelector('[data-badge-compare]'),
        pillEl: wrap.querySelector('[data-badge-pill]'),
        pctEl: wrap.querySelector('[data-badge-pct]')
      };
    }
    function atcEls() {
      var btn = root.querySelector('#ProductSubmitButton-' + sectionId);
      if (!btn) return null;
      return {
        btn: btn,
        pricesEl: btn.querySelector('.mb-atc-btn-prices'),
        sepEl: btn.querySelector('.mb-atc-btn-sep'),
        priceSpan: btn.querySelector('.mb-atc-btn-price'),
        cmpSpan: btn.querySelector('.mb-atc-btn-compare')
      };
    }

    function updateBadgeFromCents(priceCents, compareAtCents) {
      var b = badgeEls();
      if (!b) return;
      if (b.priceEl) b.priceEl.textContent = formatMoney(priceCents, moneyFmt);
      if (compareAtCents && compareAtCents > priceCents) {
        var pct = Math.floor((compareAtCents - priceCents) / compareAtCents * 100);
        if (b.compareEl) {
          b.compareEl.textContent = formatMoney(compareAtCents, moneyFmt);
          b.compareEl.classList.remove('bsw__compare--hidden');
        }
        if (b.pctEl) b.pctEl.textContent = pct + '%';
        if (b.pillEl && b.pillEl.dataset.show !== 'false') {
          b.pillEl.classList.remove('bsw__pill--hidden');
          b.pillEl.setAttribute('aria-hidden', 'false');
        }
      } else {
        if (b.compareEl) b.compareEl.classList.add('bsw__compare--hidden');
        if (b.pillEl) {
          b.pillEl.classList.add('bsw__pill--hidden');
          b.pillEl.setAttribute('aria-hidden', 'true');
        }
      }
    }

    function updateAtcFromCents(priceCents, compareAtCents) {
      var a = atcEls();
      if (!a || !a.pricesEl) return;
      a.pricesEl.style.display = '';
      if (a.sepEl) a.sepEl.style.display = '';
      if (a.priceSpan) a.priceSpan.textContent = formatMoney(priceCents, moneyFmt);
      if (a.cmpSpan) {
        if (compareAtCents && compareAtCents > priceCents) {
          a.cmpSpan.textContent = formatMoney(compareAtCents, moneyFmt);
          a.cmpSpan.style.display = '';
        } else {
          a.cmpSpan.style.display = 'none';
        }
      }
    }

    function updateFromCents(priceCents, compareAtCents) {
      updateBadgeFromCents(priceCents, compareAtCents);
      updateAtcFromCents(priceCents, compareAtCents);
    }


    function updateFromVariant(variant) {
      if (!variant) return;
      if (variant.available === false) {
        var a = atcEls();
        if (a && a.pricesEl) a.pricesEl.style.display = 'none';
        if (a && a.sepEl) a.sepEl.style.display = 'none';
        updateBadgeFromCents(variant.price, variant.compare_at_price || 0);
        return;
      }
      updateFromCents(variant.price, variant.compare_at_price || 0);
    }

    /* ── 5a. Dawn pub/sub (server-rendered HTML for exact money formatting) ── */
    if (typeof window.subscribe === 'function' && window.PUB_SUB_EVENTS && window.PUB_SUB_EVENTS.variantChange) {
      window.subscribe(window.PUB_SUB_EVENTS.variantChange, function (event) {
        var data = event && event.data;
        if (!data || data.sectionId !== sectionId) return;
        var a = atcEls();
        var newBtn = data.html && data.html.getElementById && data.html.getElementById('ProductSubmitButton-' + sectionId);
        var newPrices = newBtn && newBtn.querySelector('.mb-atc-btn-prices');
        if (a && a.pricesEl && newPrices) {
          a.pricesEl.innerHTML = newPrices.innerHTML;
          a.pricesEl.style.display = '';
          if (a.sepEl) a.sepEl.style.display = '';
          if (data.variant && data.variant.available === false) {
            a.pricesEl.style.display = 'none';
            if (a.sepEl) a.sepEl.style.display = 'none';
          }
        } else if (data.variant) {
          updateFromVariant(data.variant);
        }
      });
    }

    /* ── 5b. Legacy DOM events used by other themes/apps ── */
    document.addEventListener('variant:changed', function (e) {
      if (e.detail && e.detail.variant) updateFromVariant(e.detail.variant);
    });
    document.addEventListener('product:variantChanged', function (e) {
      if (e.detail && e.detail.variant) updateFromVariant(e.detail.variant);
    });

    /* ── 5c. Native change on the variant id input / selling-plan input ── */
    root.addEventListener('change', function (e) {
      var el = e.target;
      if (!el) return;
      if (el.name === 'id') {
        var v = getVariant(el.value);
        if (v) updateFromVariant(v);
      }
      if (el.name === 'selling_plan') {
        setTimeout(readKachingPrices, 250);
      }
    });

    /* ── 5d. MutationObserver + poll on the hidden variant input ── */
    var hiddenInput = root.querySelector('form[action*="/cart/add"] input[name="id"]');
    if (hiddenInput) {
      var lastHiddenVal = hiddenInput.value;
      var checkHidden = function () {
        if (hiddenInput.value !== lastHiddenVal) {
          lastHiddenVal = hiddenInput.value;
          var v = getVariant(lastHiddenVal);
          if (v) updateFromVariant(v);
            }
      };
      new MutationObserver(checkHidden).observe(hiddenInput, { attributes: true, attributeFilter: ['value'] });
      setInterval(checkHidden, 200);
    }

    /* ── 5e. Kaching Bundles (optional app) — read its rendered prices ──
       No-op until the app renders `.kaching-bundles__bar-price` elements. */
    var _kTimer = null;
    var _kLastPrice = -1;
    var _kLastCompare = -1;

    function getActiveKachingElements() {
      var kachingWrap = document.querySelector('.kaching-bundles');
      if (kachingWrap) {
        var checked = kachingWrap.querySelector('input[type="radio"]:checked');
        if (checked) {
          var row = checked.parentElement;
          while (row && row !== kachingWrap) {
            var bp = row.querySelector('.kaching-bundles__bar-price');
            var bfp = row.querySelector('.kaching-bundles__bar-full-price');
            if (bp && bfp) return { barPrice: bp, barFullPrice: bfp };
            row = row.parentElement;
          }
        }
      }
      var activeCandidates = [
        '.kaching-bundles__bar--selected', '.kaching-bundles__bar--active',
        '.kaching-bundles__bar.is-selected', '.kaching-bundles__bar.is-active',
        '.kaching-bundles__bar.selected', '.kaching-bundles__bar.active'
      ];
      for (var i = 0; i < activeCandidates.length; i++) {
        var activeRow = document.querySelector(activeCandidates[i]);
        if (activeRow) {
          var abp = activeRow.querySelector('.kaching-bundles__bar-price');
          var abfp = activeRow.querySelector('.kaching-bundles__bar-full-price');
          if (abp && abfp) return { barPrice: abp, barFullPrice: abfp };
        }
      }
      return {
        barPrice: document.querySelector('.kaching-bundles__bar-price'),
        barFullPrice: document.querySelector('.kaching-bundles__bar-full-price')
      };
    }

    function readKachingPrices() {
      if (_kTimer) clearTimeout(_kTimer);
      _kTimer = setTimeout(function () {
        var els = getActiveKachingElements();
        if (!els.barPrice || !els.barFullPrice) return;
        var priceText = (els.barPrice.innerText || '').trim();
        var fullPriceText = (els.barFullPrice.innerText || '').trim();
        if (!priceText || !fullPriceText) return;
        var priceCents = parseToCents(priceText);
        var compareAtCents = parseToCents(fullPriceText);
        if (priceCents <= 0 || compareAtCents <= 0) return;
        if (priceCents === _kLastPrice && compareAtCents === _kLastCompare) return;
        _kLastPrice = priceCents;
        _kLastCompare = compareAtCents;
        updateFromCents(priceCents, compareAtCents);
      }, 50);
    }

    function attachKachingObserver() {
      var barPrice = document.querySelector('.kaching-bundles__bar-price');
      var barFullPrice = document.querySelector('.kaching-bundles__bar-full-price');
      if (!barPrice || !barFullPrice) return false;
      readKachingPrices();
      var directObs = new MutationObserver(readKachingPrices);
      directObs.observe(barPrice, { subtree: true, childList: true, characterData: true });
      directObs.observe(barFullPrice, { subtree: true, childList: true, characterData: true });
      var kachingRoot = (
        document.querySelector('.kaching-bundles__bar-pricing') ||
        document.querySelector('.kaching-bundles__bar-wrapper') ||
        document.querySelector('.kaching-bundles') ||
        root
      );
      new MutationObserver(readKachingPrices).observe(kachingRoot, { subtree: true, childList: true, characterData: true });
      return true;
    }

    if (!attachKachingObserver()) {
      var _kPollN = 0;
      var _kPoll = setInterval(function () {
        _kPollN++;
        if (attachKachingObserver() || _kPollN >= 50) clearInterval(_kPoll);
      }, 100);
    }

    ['kaching:price:updated', 'kaching:bundle:selected', 'kaching:subscription:changed',
      'kaching:subscription:toggled', 'kaching:autoship:changed', 'kaching:selling_plan:changed'
    ].forEach(function (name) { document.addEventListener(name, readKachingPrices); });
  }

  /* ------------------------------------------------------------------ */
  /* 5. Why-trust reveal (source SCRIPT#9)                               */
  /* ------------------------------------------------------------------ */
  function initWhyTrust(root) {
    root.querySelectorAll('.wt-block').forEach(function (wrapper) {
      if (wrapper.dataset.wtInit) return;
      wrapper.dataset.wtInit = '1';
      if ('IntersectionObserver' in window) {
        var observer = new IntersectionObserver(function (entries) {
          entries.forEach(function (entry) {
            if (entry.isIntersecting) {
              wrapper.classList.add('reveal-active');
              observer.unobserve(wrapper);
            }
          });
        }, { threshold: 0.15 });
        observer.observe(wrapper);
      } else {
        wrapper.classList.add('reveal-active');
      }
    });
  }

  /* ------------------------------------------------------------------ */
  /* 6. Accordion animation (source SCRIPT#13)                           */
  /* ------------------------------------------------------------------ */
  function initAccordions(root) {
    root.querySelectorAll('.product__accordion details').forEach(function (details) {
      if (details.dataset.accordionInitialized) return;
      details.dataset.accordionInitialized = 'true';

      var summary = details.querySelector('summary');
      var content = details.querySelector('.accordion__content');
      if (!summary || !content) return;

      var isAnimating = false;

      summary.addEventListener('click', function (e) {
        e.preventDefault();
        if (isAnimating) return;
        isAnimating = true;

        var onTransitionEnd;
        if (details.hasAttribute('open')) {
          // --- Close ---
          content.style.maxHeight = content.scrollHeight + 'px';
          void content.offsetHeight; // reflow
          content.style.transition = 'max-height 0.3s cubic-bezier(0.4, 0, 0.2, 1), opacity 0.3s cubic-bezier(0.4, 0, 0.2, 1), padding 0.3s ease';
          content.style.maxHeight = '0px';
          content.style.opacity = '0';
          content.style.paddingTop = '0px';
          content.style.paddingBottom = '0px';

          onTransitionEnd = function (event) {
            if (event.propertyName !== 'max-height') return;
            details.removeAttribute('open');
            ['max-height', 'opacity', 'padding-top', 'padding-bottom', 'transition'].forEach(function (p) { content.style.removeProperty(p); });
            isAnimating = false;
            content.removeEventListener('transitionend', onTransitionEnd);
          };
          content.addEventListener('transitionend', onTransitionEnd);
        } else {
          // --- Open ---
          content.style.maxHeight = '0px';
          content.style.opacity = '0';
          content.style.paddingTop = '0px';
          content.style.paddingBottom = '0px';
          details.setAttribute('open', 'true');
          void content.offsetHeight; // reflow
          content.style.transition = 'max-height 0.35s cubic-bezier(0.4, 0, 0.2, 1), opacity 0.35s cubic-bezier(0.4, 0, 0.2, 1), padding 0.35s ease';
          content.style.maxHeight = (content.scrollHeight + 40) + 'px';
          content.style.opacity = '1';
          content.style.paddingTop = '20px';
          content.style.paddingBottom = '24px';

          onTransitionEnd = function (event) {
            if (event.propertyName !== 'max-height') return;
            ['max-height', 'opacity', 'padding-top', 'padding-bottom', 'transition'].forEach(function (p) { content.style.removeProperty(p); });
            isAnimating = false;
            content.removeEventListener('transitionend', onTransitionEnd);
          };
          content.addEventListener('transitionend', onTransitionEnd);
        }
      });
    });
  }

  /* ------------------------------------------------------------------ */
  /* Bootstrap per section instance                                      */
  /* ------------------------------------------------------------------ */
  function initSection(root) {
    if (root.dataset.verolaeInit) return;
    root.dataset.verolaeInit = '1';
    var sectionId = root.dataset.section;
    initGalleryArrows(root, sectionId);
    initDragScroll(root, sectionId);
    root.querySelectorAll('.ugc-grid-wrapper').forEach(initUgc);
    initProgress(root);
    initPriceSync(root, sectionId);
    initWhyTrust(root);
    initAccordions(root);
  }

  function initAll() {
    document.querySelectorAll('product-info.verolae-main-product').forEach(initSection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (e) {
    var el = e.target && e.target.querySelector ? e.target.querySelector('product-info.verolae-main-product') : null;
    if (el) initSection(el);
  });
})();

